<template>
    <div class='contener'>
        <div class='title'>
          <img :src="setImg(model)" class='item_icon'>
          <span>{{model.goodsName}}</span>
        </div>
        <div class='service_detail'>
          <img src="/images/order/top_arrow.png" class='item_top'>
          <div class='list_item' v-if='model.unpaidCuringService && model.unpaidCuringService.length != 0'>
            <div class='item_title'>未付</div>
            <ul>
              <li v-for='(item,index) in model.unpaidCuringService' :key='index'>
                <span>{{item.curingServiceName}}</span>
                <div>
                  <span>{{item.priceText}}</span>
                  <span>x{{item.quantity}}</span>
                </div>
              </li>
            </ul>
          </div>
          <div class='list_item' v-if='model.paidCuringService && model.paidCuringService.length != 0'>
            <div class='item_title'>已付</div>
            <ul>
              <li v-for='(item,index) in model.paidCuringService' :key='index'>
                <span>{{item.curingServiceName}}</span>
                <div>
                  <span>{{item.priceText}}</span>
                  <span>x{{item.quantity}}</span>
                </div>
              </li>
            </ul>
          </div>
          <div class='list_item'  v-if='model.settlementDiscount && model.settlementDiscount.length != 0'>
            <div class='item_title'>活动抵扣</div>
            <ul>
              <li v-for='(item,index) in model.settlementDiscount' :key='index'>
                <span>{{item.name}}</span>
                <div>
                  <span>{{item.value}}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'goods-item',
    data(){
      return {
       
      }
    },
    props: {
      model : {
        type : Object,
        default : ()=>{
          return {}
        }
      }
    },
    methods:{
      formatImgUrl(url, width, height,m_fill) {
        // console.log(url)
        if (url) {
          url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
          // url = url.replace(',jpg', ",webp");
          url +=',q_80';
          if(m_fill){
            // console.log(m_fill)
            url = url.replace('m_lfit', "m_fill");
          }
        }
        return url
      },
      setImg(item){
        if(item.goodsType == 'goods'){
          return this.formatImgUrl(item.picTemplate,300,300,true)
        }else{
          if(item.categoryId == 3){
            return '/images/newOrder/package1.png'
          }else if(item.categoryId == 4){
            return '/images/newOrder/shoes1.png'
          }else if(item.categoryId == 5){
            return '/images/newOrder/pajamas1.png'
          }else if(item.categoryId == 6){
            return '/images/newOrder/accessories1.png'
          }else{
            return '/images/base/defult_pic.png'
          }
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .contener{
    padding: 30px;
    padding-top: 0px;
    .title{
      display: flex;
      color:#333333;
      font-size: 30px;
      line-height: 60px;
      span{
        margin-left: 16px;
        font-weight:500; 
      }
      img{
        width: 60px;
        height: 60px;
        border-radius:6px; 
      }
    }
    .service_detail{
      padding: 10px 20px;
      background: #F7F9F9;
      margin-top: 16px;
      position: relative;
      border-radius:6px;
      .item_top{
        position: absolute;
        width: 24px;
        top:-7px;
        left:18px;
      }
      
      .list_item{
        border-bottom:1px dashed #DEE4E4;
        margin-top: 20px;
        &:last-child{
          border-bottom:none!important;
        }
        .item_title{
          font-size:26px;
          color:#333333;
          font-weight: 500; 
        }
        li{
          display: flex;
          justify-content:space-between;
          color:#666666;
          font-size: 24px;
          margin-top:20px;
          margin-bottom: 20px; 
          div{
            color:#333333;
            span{
              margin-left: 56px;
            }
          }
        }
      }
    }
  }
</style>
